export default __webpack_public_path__ + "static/media/solution.22b93ce3.webp";